import type { NlRcphResolvedActivity } from './nl-rcph-archi-activities.ts'

export const NL_RCPH_EXECUTOR_MANDATORY_DOUBLE_LIMIT_PER_CLAIM = 500_000 as const

export const NL_RCPH_EXECUTOR_PI_LIMITS = [500_000, 1_000_000, 1_250_000] as const

export const nlRcphExecutorActivityIds = ['act_01kt1ank20f6a9m07f9nphytey', 'act_01kt1ank20f6a9m09tkwfwbbvz'] as const

export function isNlRcphExecutorActivity(activities: readonly Pick<NlRcphResolvedActivity, 'activityId'>[]): boolean {
  return activities.some(({ activityId }) =>
    nlRcphExecutorActivityIds.some((executorActivityId) => executorActivityId === activityId),
  )
}

export function hasNlRcphExecutorMandatoryDoubleLimit(
  perClaimLimit: number,
  activities: readonly Pick<NlRcphResolvedActivity, 'activityId'>[],
): boolean {
  return isNlRcphExecutorActivity(activities) && perClaimLimit === NL_RCPH_EXECUTOR_MANDATORY_DOUBLE_LIMIT_PER_CLAIM
}

export function isNlRcphExecutorDoubleLimitSelectable(
  perClaimLimit: number,
  activities: readonly Pick<NlRcphResolvedActivity, 'activityId'>[],
): boolean {
  return !hasNlRcphExecutorMandatoryDoubleLimit(perClaimLimit, activities)
}
